<template>
  <div
    class="tw-mr-4 tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start"
  >
    <label
      class="tw-mr-4 tw-whitespace-nowrap tw-text-sm tw-text-primary-grey-700"
      for="row-per-page-select"
    >
      {{ placeholder }}
    </label>
    <select
      id="row-per-page-select"
      name="row-per-page-select"
      class="tw-focus:border-gray-200 peer tw-block tw-w-full tw-appearance-none tw-border-0 tw-border-b-2 tw-border-solid tw-border-primary-grey-300/80 tw-bg-white tw-text-sm tw-text-primary-grey-700 tw-outline-none focus:tw-border-primary-grey-700 focus:tw-ring-0"
      :value="pageSize"
      :disabled="disabled"
      @change="handlePageSizeChange"
    >
      <option v-for="size in pageSizes" :key="size" :value="size">
        {{ size }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps<{
  placeholder: string;
  pageSize: number;
  pageSizes: number[];
  handlePageSizeChange: (e: Event) => void;
  disabled?: boolean;
}>();

const { placeholder, pageSize, pageSizes, handlePageSizeChange, disabled } =
  toRefs(props);
</script>
